import { useBoundStore } from "@maxis/client-logic/store/useBoundStore";

export default function useLoadingIndicator() {
  const setLoading = useBoundStore((state) => state.loadingIndicator.setLoading);

  const showLoading = () => {
    setLoading(true);
  };

  const hideLoading = () => {
    setLoading(false);
  };

  return {
    showLoading,
    hideLoading,
  };
}
